import Page from './page.pi';

export { Page };
